import { ApiFlagMessage } from '../actions/Api';

export function flagMessage(artistMessageId, artistUid, reason, trackId) {
  return dispatch => {
    return dispatch(ApiFlagMessage({ artistMessageId, artistUid, reason, trackId }));
  };
}
